import { JOURS_MOIS_PAIE, PLAFOND_TRANSPORT_EXONERE } from '@shared/constants/Taux';
import { roundFCFA } from '@shared/utils/round';

export interface SplitIndemniteExoneration {
  /** Part exonérée (cat3 — hors brut, ajoutée au net). */
  exonere: number;
  /** Excédent cotisable (cat2 — brut / CNSS, hors CNAMGS). */
  cotisable: number;
  /** Plafond d’exonération proratisé en trentièmes. */
  plafond: number;
}

/**
 * Répartit une indemnité plafonnée (transport Sophie : 35 000 F / mois).
 * Mois incomplet : plafond × jours / 30.
 */
export function splitIndemniteExoneration(
  verse: number,
  plafondMensuel: number = PLAFOND_TRANSPORT_EXONERE,
  joursPayes: number = JOURS_MOIS_PAIE,
): SplitIndemniteExoneration {
  const montant = Math.max(0, verse);
  const jours = Math.min(Math.max(joursPayes, 0), JOURS_MOIS_PAIE);
  const plafond = roundFCFA(plafondMensuel * (jours / JOURS_MOIS_PAIE));
  const exonere = roundFCFA(Math.min(montant, plafond));
  const cotisable = roundFCFA(Math.max(0, montant - exonere));
  return { exonere, cotisable, plafond };
}
